import VModel from "@/vuetify_custom/v-modal_v1";
import { getRecordsRank } from "../service";
import { DATE_TIME_FORMATE } from "../../../../libs/constants";
import moment from "moment";
import { VDataTable, VSelect, VAlert } from "vuetify/lib/components";
import { makeSlots } from "../../../fin/salaryadministration/utils";

function getTimeSpan(span) {
  const start = new Date();
  const end = new Date();
  start.setDate(start.getDate() - span);
  return {
    start,
    end,
  };
}

export default {
  data() {
    const { start, end } = getTimeSpan(3);
    return {
      dis: false,
      url: "",
      startTime: start,
      endTime: end,
      loading: false,
      headers: [
        {
          text: "关键字",
          // align: 'start',
          sortable: false,
          value: "keyword",
        },
        {
          text: "排名",
          value: "rank",
        },
        {
          text: "搜索时间",
          value: "taskTime",
        },
      ],
      items: [],
      spanList: [
        {
          label: "三天",
          value: 3,
        },
        {
          label: "五天",
          value: 5,
        },
        {
          label: "七天",
          value: 7,
        },
      ],
      timeSpan: 3,
    };
  },
  computed: {
    
  },
  watch: {
    timeSpan(val) {
      const {start, end} = getTimeSpan(val)
      this.startTime = start;
      this.endTime = end;
    },
    startTime() {
      this.getData()
    },
    url() {
      this.getData()
    }
  },
  methods: {
    showRank(url) {
      this.dis = true;
      this.url = url;
    },
    getData() {
      if (!this.dis || !this.url) return;
      this.loading = true;
      getRecordsRank({
        xhsNoteUrl: this.url,
        startTime: this.dateFormate(this.startTime),
        endTime: this.dateFormate(this.endTime),
      }).then((res) => {
        if (res.items) {
          this.items = res.items;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    submit() {
      this.dis = false;
      this.reset()
    },
    cancel() {
      this.dis = false;
      this.reset()
    },
    reset() {
      this.url = "";
      this.timeSpan = 3;
      this.items = [];
    },
    dateFormate(date) {
      return moment(date).format(DATE_TIME_FORMATE);
    },
  },
  render() {
    return (
      <VModel
        v-model={this.dis}
        persistent
        dynamic-height
        title={"市场舆情数据"}
        max-width="600"
        loading={this.loading}
        on={{
          ok: this.submit,
          cancel: this.cancel,
        }}
      >
        {!this.url && <VAlert
          type="warning"
        >没有设置投放地址</VAlert>}
        <VSelect
          items={this.spanList}
          label="时间跨度"
          item-text="label"
          item-value="value"
          v-model={this.timeSpan}
          disabled={this.loading}
        />
        <VDataTable
          headers={this.headers}
          items={this.items}
          hide-default-footer
          loading={this.loading}
          items-per-page={-1}
          scopedSlots={{
            "item.taskTime": makeSlots(({ item }) => {
              return <span>{this.dateFormate(item.taskTime)}</span>;
            }),
          }}
        />
      </VModel>
    );
  },
};
